import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FocusSelectOnDirective } from '../../../directives/focus-select.directive';
import { MaskDirective } from '../../../directives/mask-directive/mask.directive';
import { MaskedDateCellEditorBaseComponent } from '../masked-date-cell-editor-base/masked-date-cell-editor-base.component';

/**
 * Inline DateTime/Date/Time Input Custom Editor
 */
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-masked-date-cell-editor-inline',
    templateUrl: './masked-date-cell-editor-inline.component.html',
    styleUrls: ['./masked-date-cell-editor-inline.component.scss'],
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, FocusSelectOnDirective, MaskDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaskedDateCellEditorInlineComponent extends MaskedDateCellEditorBaseComponent {}
